import { render, staticRenderFns } from "./car-about-dealer.vue?vue&type=template&id=6c33bdec"
import script from "./car-about-dealer.vue?vue&type=script&lang=js"
export * from "./car-about-dealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports